declare global {
  interface Window {
    fbq: (...args: any[]) => void
    _fbq: (...args: any[]) => void
  }
}

// Standard Meta pixel events
const STANDARD_EVENTS = [
  'PageView',
  'ViewContent',
  'Search',
  'AddToCart',
  'AddToWishlist',
  'InitiateCheckout',
  'AddPaymentInfo',
  'Purchase',
  'Lead',
  'CompleteRegistration',
  'Contact',
  'CustomizeProduct',
  'Donate',
  'FindLocation',
  'Schedule',
  'StartTrial',
  'SubmitApplication',
  'Subscribe',
]

export function trackMetaEvent(
  eventName: string,
  eventParams?: Record<string, any>,
) {
  const sendEvent = () => {
    if (typeof window === 'undefined' || !window.fbq) return false

    const isStandardEvent = STANDARD_EVENTS.includes(eventName)
    const trackingMethod = isStandardEvent ? 'track' : 'trackCustom'

    if (eventParams) {
      window.fbq(trackingMethod, eventName, eventParams)
    } else {
      window.fbq(trackingMethod, eventName)
    }

    return true
  }

  if (sendEvent() || typeof window === 'undefined') return

  window.setTimeout(() => {
    if (!sendEvent()) {
      console.warn('[trackMetaEvent] fbq not available, event not tracked:', eventName)
    }
  }, 1000)
}
